class DebugMode {
    constructor(map) {
        this.map = map;
        this.debugMode = false;

        this.toggleDebugMode();
    }

    toggleDebugMode() {
        document.addEventListener('keydown', (e) => {
            if (e.key.toLowerCase() === 'd') {
                this.debugMode = !this.debugMode;
                this.toggleCoordinateBox();
                this.coordinateHandler();
            }
        });
    }

    toggleCoordinateBox() {
        const mapContainer = document.getElementById('osm-map');
        const canvas = document.querySelector('.maplibregl-canvas-container.maplibregl-interactive, .maplibregl-ctrl-group button.maplibregl-ctrl-compass');

        if(this.debugMode) {
            const coordinateBox = document.createElement('div');
            coordinateBox.id = 'coordinate-box';
            coordinateBox.textContent = 'Rechtsklick, um Koordinaten anzuzeigen';
            mapContainer.appendChild(coordinateBox);

            // Set cursor to a more precise one
            canvas.style.cursor = 'pointer';
        } else {
            const coordinateBox = document.getElementById('coordinate-box');
            coordinateBox.remove();

            // Set cursor back to default one
            canvas.style.cursor = null;
        }
    }

    coordinateHandler() {
        if(this.debugMode) {
            const coordinateBox = document.getElementById('coordinate-box');

            this.map.on('contextmenu', (event) => {
                const lng = event.lngLat.lng;
                const lat = event.lngLat.lat;

                coordinateBox.innerHTML = `${lng} ${lat}`;
            });

            coordinateBox.addEventListener('click', () => {
                const content = coordinateBox.innerHTML;

                navigator.clipboard.writeText(content).then(() => {
                    coordinateBox.innerHTML += ' \u2705';
                });
            });
        }
    }
}

export default DebugMode;
